/* global data, serverParams */

import React, { useEffect, useState } from 'react'
import { render } from 'react-dom'
import type { SwingTimingData } from 'leaderboard/scripts/swing-path/types/globals'

import SwingTimingWrapper from './Wrapper.tsx'
import SwingTimingChart from './swing-timing-chart.ts'
import initSwingTimingCharts from './distribution.ts'

const $app = document.getElementById('swing-timing-app')

function SwingTimingApp() {
    const [charts, setCharts] = useState<SwingTimingChart[]>([])

    useEffect(() => {
        setCharts(initSwingTimingCharts())
    }, [])

    return (
        <SwingTimingWrapper
            data={data as SwingTimingData[]}
            charts={charts}
            groupBys={serverParams.secondarySplit}
            type={serverParams.type}
        />
    )
}

if ($app) {
    render(<SwingTimingApp />, $app)
}
